import { defineStore, acceptHMRUpdate } from 'pinia'
import { APP_NAME } from '@/define/constants'
import store from '../index'
import { userInfoApi, postAgentInfoByHref } from '@/api/user'
import { ElMessageBox } from 'element-plus'
import { maUrlLinkGenerateUrl } from '@/api/course'

import hqtXcxImg from '@/assets/img/hqt-xcx.jpg'
import nxjpXcxImg from '@/assets/img/nxjp-xcx.png'

const STORE_KEY = APP_NAME + '-USER'

export const useUserStore = defineStore({
  id: STORE_KEY,
  state: (): UserState => ({
    token: '',
    userInfo: null,
    preHistory: '',
    showLogin: false,
    currentNote: '',
    agentInfo: {},
  }),
  getters: {
    getToken: (state: UserState): string => {
      return state.token
    },
    hasLogged: (state: UserState): boolean => !!state.token,
    //TODO:需要获取用户信息后使用此逻辑 !!state.token && !!state.userInfo?.userId,
    getUserInfo: (state: UserState): UserInfo | null => {
      return state.userInfo as UserInfo
    },
    getShowLoginStatus: (state: UserState): boolean => {
      return state.showLogin
    },
  },
  actions: {
    async logout() {
      // await loginApi.logout()
      this.removeToken()
      this.setUserInfo()
      // window.location.reload()
    },
    setToken(data: string) {
      this.token = data
    },
    removeToken() {
      this.token = ''
    },
    setUserInfo(data?: object) {
      if (!data) {
        this.userInfo = null
        return
      }
      if (!this.userInfo) {
        this.userInfo = {}
      }
      Object.assign(this.userInfo, data || {})
    },
    // async getUserInfo() {
    //   const userRes = await userInfoApi()
    //   this.setUserInfo(userRes?.data)
    // },
    removeUserInfo() {
      this.userInfo = null
    },
    async initUserInfo() {
      const userRes = await userInfoApi()
      this.setUserInfo(userRes?.data.user)
      return Promise.resolve()
    },
    setHistory(history: string) {
      this.preHistory = history
    },
    setShowLogin(showLogin: boolean) {
      this.showLogin = showLogin
    },
    // 保存currentNote
    setCurrentNote(currentNote: string) {
      this.currentNote = currentNote
    },
    // 域名获取代理商信息
    getAgentInfo() {
      return new Promise(async (resolve, reject) => {
        try {
          // const { data } = await postAgentInfoByHref(location.host)
          // this.agentInfo = data || {}
          // 检测用户代理字符串
          const userAgent = navigator.userAgent
          // 判断是否为微信浏览器（优先检测）
          const isWeChat = /MicroMessenger/i.test(userAgent)

          if (isWeChat) {
            console.log('456') // 微信浏览器访问
            const isWeChatPC =
              isWeChat &&
              !/Mobile|iPhone|Android|iPad|iPod/i.test(navigator.userAgent)
            if (isWeChatPC) {
              //电脑微信浏览器
              if (import.meta.env.VITE_APP_PLATFORM_TYPE == 'nxjp') {
                ElMessageBox.alert(
                  `<div style="text-align:center;">推荐使用电脑端谷歌浏览器打开宁夏建培平台进行学习；<br/>也可在手机端打开微信，扫码进入宁夏建培小程序学习。<br/><img src="${nxjpXcxImg}" alt="宁夏建培小程序二维码" style="margin-top:10px;max-width:180px;width:100%;border-radius:8px;" /></div>`,
                  '温馨提示',
                  {
                    type: 'warning',
                    center: true,
                    customClass: 'mobile-warning-dialog',
                    showCancelButton: false,
                    showConfirmButton: false,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showClose: false,
                    dangerouslyUseHTMLString: true,
                  }
                )
              } else {
                ElMessageBox.alert(
                  `<div style="text-align:center;">推荐使用电脑端谷歌浏览器打开行企通平台进行学习；<br/>也可在手机端打开微信，扫码进入行企通小程序学习。<br/><img src="${hqtXcxImg}" alt="行企通小程序二维码" style="margin-top:10px;max-width:180px;width:100%;border-radius:8px;" /></div>`,
                  '温馨提示',
                  {
                    type: 'warning',
                    center: true,
                    customClass: 'mobile-warning-dialog',
                    showCancelButton: false,
                    showConfirmButton: false,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showClose: false,
                    dangerouslyUseHTMLString: true,
                  }
                )
              }
            } else {
              maUrlLinkGenerateUrl(
                import.meta.env.VITE_APP_PLATFORM_TYPE,
                'pages/buyCourseCenter/buyCourseCenter'
              )
                .then(res => {
                  window.location.href = res.data
                })
                .catch(() => {
                  ElMessageBox.alert(`系统错误，无法跳转到小程序`, '提示', {
                    type: 'warning',
                    center: true,
                    showCancelButton: false,
                    showConfirmButton: false,
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    showClose: false,
                  })
                })
            }
            // 微信浏览器访问
            // ElMessageBox.confirm('手机端学习请点击下方按钮跳转到“宁夏建培”小程序？', '提示', {
            //   type: 'warning',
            //   center: true,
            //   showCancelButton: false,
            //   showConfirmButton: true,
            //   confirmButtonText: '前往小程序',
            //   customClass: 'wechat-mini-confirm',
            //   closeOnClickModal: false,
            //   closeOnPressEscape: false,
            //   showClose: false,
            // }).then(() => {
            //   // 用户点击了前往小程序
            //   try {
            //     // 方式2: 延迟跳转，确保页面加载完成
            //     setTimeout(() => {
            //       window.location.href = '#小程序://宁夏建培/pUlEnEh0geWRJtq'
            //     }, 100)
            //   } catch (error) {
            //     // 跳转失败时显示提示
            //     ElMessageBox.alert(
            //       '请在微信中搜索"宁夏建培"小程序进行学习',
            //       '提示',
            //       {
            //         type: 'warning',
            //         center: true,
            //         showCancelButton: false,
            //         showConfirmButton: false,
            //       }
            //     )
            //   }
            // })
            return // 微信浏览器访问时直接返回，不执行后续的移动端检测
          }

          // 判断是否为移动端（非微信浏览器）
          const isMobile =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
              userAgent
            )
          if (isMobile) {
            console.log('123') // 移动端访问
            // 执行移动端逻辑
            if (import.meta.env.VITE_APP_PLATFORM_TYPE == 'nxjp') {
              ElMessageBox.alert(
                '请用电脑浏览器打开宁夏建培网站学习，手机等移动设备请在微信小程序"宁夏建培"中学习。有任何疑问也可关注"宁夏建培"微信公众号唤起在线客服咨询。',
                '提示',
                {
                  type: 'warning',
                  center: true,
                  customClass: 'mobile-warning-dialog',
                  showCancelButton: false,
                  showConfirmButton: false,
                  closeOnClickModal: false,
                  closeOnPressEscape: false,
                  showClose: false,
                }
              )
            } else {
              ElMessageBox.alert(
                '请用电脑浏览器打开行信通网站学习，手机等移动设备请在微信小程序"行企通"中学习。有任何疑问也可关注"行企通"微信公众号唤起在线客服咨询。',
                '提示',
                {
                  type: 'warning',
                  center: true,
                  customClass: 'mobile-warning-dialog',
                  showCancelButton: false,
                  showConfirmButton: false,
                  closeOnClickModal: false,
                  closeOnPressEscape: false,
                  showClose: false,
                }
              )
            }
          }
          // resolve(data)
        } catch (e) {
          // reject(e)
        }
      })
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        storage: sessionStorage, // $localStorage,
        paths: ['token', 'currentNote', 'agentInfo'], //可以选择保存的字段  其余的不保存
      },
      // {
      //   storage: sessionStorage,
      //   paths: ['preHistory'], //可以选择保存的字段  其余的不保存
      // },
    ],
  },
})
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot))
}
export const useUserStoreWithout = () => {
  return useUserStore(store)
}
